export const css = {
    root: '_1yMhcs9E',
    actions: '_2E9_6uGs',
    actionButtons: '_3fHvP2L3',
    actionIcons: '_197N0cQl',
    primary: 'G8Ln6onp',
    content: '_2mLdis8h',
    media: '_1gw5Gkw7',
    mediaSquare: '_3mnEebPQ',
    media16by9: '_3wn5qQqd',
    header: '_2Fr1Cgn4',
    titleWrapper: 'FmekofZj',
    contentWrapper: 'g2IA8hVx',
    title: '_2SDMAGYh',
    subtitle: '_3qpew49t',
    ' _key': 'afcpe-theme/dojo/card'
};
export default css;
